import { render } from "./TableBody.vue?vue&type=template&id=61ba8698"
const script = {}

import "./TableBody.vue?vue&type=style&index=0&id=61ba8698&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__